import { render, staticRenderFns } from "./SSRTable.vue?vue&type=template&id=3b886c8b&scoped=true&"
import script from "./SSRTable.vue?vue&type=script&lang=js&"
export * from "./SSRTable.vue?vue&type=script&lang=js&"
import style0 from "./SSRTable.vue?vue&type=style&index=0&id=3b886c8b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b886c8b",
  null
  
)

export default component.exports